<!--
 * @Author: your name
 * @Date: 2020-11-18 20:26:17
 * @LastEditTime: 2020-11-19 10:54:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/cart/component/TipPercentBox/index.vue
-->
<style scoped lang="sass">
.tip_percent_box
  position: relative
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  height: 67PX
  width: 28%
  border: 1PX solid #e2e2e2
  background: #f8f8f8
  border-radius: 4PX

.percent_num
  font-size: 21PX
  line-height: 25PX
  margin-bottom: 7PX

.money
  font-size: 15PX
  line-height: 18PX

.choosed
  // background-color: var(--menu-primary-background-colour)
  border: 1px solid var(--menu-primary-background-colour)

.mask
  position: absolute
  top: 0
  bottom: 0
  left: 0
  right: 0
  background-color: var(--menu-primary-background-colour)
  opacity: .1
  z-index: 0

</style>

<template lang="pug">
.tip_percent_box(:class="{'choosed': choosed}" @click="choosePercentNum")
  .percent_num.b {{ percentNum }}%
  .money {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ money }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
  .mask(v-show="choosed")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getCurrencySymbol, getSymbolPosition } from '@/utils/currency'

@Component({
  props: {
    percentNum: {
      type: [String, Number],
      default: 5
    },
    money: {
      type: String,
      default: '3.86'
    },
    activeIndex: {
      type: Number
    },
    index: {
      type: Number
    }
  },

  watch: {
    activeIndex() {
      if (this.activeIndex === this.index) {
        this.choosed = true
        // 只报选中的下标；金额由付款页按数值算（utils/feeChain.js tipAmountFor），`money` 是带本地化小数点的显示串，
        // 不能当钱往上传（review 第 1 轮 #10，UL-8 的后续）
        this.$emit('choosed', this.activeIndex)
      } else {
        this.choosed = false
      }
    },
  },

  computed: {
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  }
})
class TipPercentBox extends Vue {
  choosed = false

  choosePercentNum() {
    this.$emit('update:activeIndex', this.index)
  }
}

export default TipPercentBox
</script>
